.activity-list {
    height: 100%;
    margin-top: -40px;
    box-sizing: border-box;
    background-color: white;
}
